var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCommunication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M17.9 5h-1.663v7.5H5.425v1.667c0 .458.375.833.832.833h9.148l3.327 3.333v-12.5A.835.835 0 0017.9 5zm-3.326 5V2.5a.835.835 0 00-.832-.833H2.93a.835.835 0 00-.831.833v11.667l3.326-3.334h8.317a.835.835 0 00.832-.833z"
  })));
}
export default __webpack_public_path__ + "6375dfc3858dae9d501d305b988668ee.svg";
export { SvgIconCommunication as ReactComponent };